import React from 'react'
import AdminLayout from '../sidebar-layout/AdminLayout'
import Settings from './Settings'


const AdminSettings = () => {
  return (
    <AdminLayout><Settings/></AdminLayout>
  )
}

export default AdminSettings